













































































import { Component, Vue } from "vue-property-decorator";
import { ifValid, processError, resetValidate } from "@/utils/ComponentUtils";
import LandingInput from "@/components/landing/common/LandingInput.vue";
import LandingSelect from "@/components/landing/common/LandingSelect.vue";
import LandingTextarea from "@/components/landing/common/LandingTextarea.vue";
import LandingPhoneInput from "@/components/landing/common/LandingPhoneInput.vue";
import Application from "@/state/Application";
import PublicService from "@/services/PublicService";
import FeedbackDTO from "@/dto/FeedbackDTO";
import RouteNames from "@/router/RouteNames";
import Notifications from "@/state/Notifications";

@Component({
  components: {
    LandingInput,
    LandingSelect,
    LandingTextarea,
    LandingPhoneInput,
  },
  computed: {
    RouteNames() {
      return RouteNames;
    }
  }
})
export default class BecomeClient extends Vue {
  private feedback = new FeedbackDTO();
  private languages = [{ title: 'English', value: 'EN' }, { title: 'Русский', value: 'RU' }];

  sendFeedback(): void {
    ifValid(this, () => {
      Application.startLoading();
      PublicService.sendFeedback(this.feedback).then(
        response => {
          Application.stopLoading();
          Notifications.success(this.$t("profile.we_will_contact") as string);
          this.feedback = new FeedbackDTO();
          resetValidate(this);
        },
        error => {
          Application.stopLoading();
          processError(error, this);
        }
      );
    })
  }

  goLogin(): void {
    this.$emit('toggleMode', 'Login');
  }

  get isPhoneFilled(): boolean {
    return this.feedback.phone !== undefined && this.feedback.phone !== null && this.feedback.phone !== "";
  }
}
